<section class="wraper-sub">
  <div class="lead-m">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">Available Orders</h1>
      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m">
              <input type="text" name="search" [(ngModel)]="searchParams.order_id" (change)="rerender()" placeholder="Search by Order ID">
              <i class="fa fa-search" aria-hidden="true" (change)="rerender()"></i>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m date-filter">
              <input (onHidden)="splitFromTo()" [(ngModel)]="fullRangeDate" type="text" placeholder="Date Range" bsDaterangepicker [bsConfig]="{ isAnimated: true, showWeekNumbers: false}" >
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z" fill="#1C212D"/>
                <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#1C212D"/>
                <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#1C212D"/>
                <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#1C212D"/>
                <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#1C212D"/>
                <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#1C212D"/>
                <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#1C212D"/>
                <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#1C212D"/>
                <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#1C212D"/>
                <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#1C212D"/>
                <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#1C212D"/>
                <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#1C212D"/>
                <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#1C212D"/>
                <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#1C212D"/>
                <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#1C212D"/>
              </svg>
            </div>
          </div>
          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z" fill="#1C212D"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-tables-m">
      <div class="table-responsive">
        <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
            <tr>
              <th>Sr</th>
              <th>Order ID</th>
              <th>Timestamp</th>
              <th>Region</th>
              <th>Pages</th>
              <th>Due Date</th>
              <th>History</th>
              <th>Assign</th>
            </tr>
          </thead>

          <!-- For Proofreaders -->
          <ng-container *ngIf="leads.data && leads.data.length > 0">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td class="sr-no">{{ paginatePage + (indx + 1) }}</td>
                <td class="id">
                  <!-- <a class="withIcon" href="javascript:;" routerLink="/order-detail/{{ lead.order_id | base64 }}" target="_blank"> -->
                  <a class="withIcon" href="javascript:;">
                      {{ lead.order_id }}
                  </a>
                </td>
                <td>
                  <p *ngIf="lead.date" class="time-done">{{ lead.date | date }}</p>
                  <p class="time-done">{{ lead.date | date:'shortTime' }}</p>
                </td>
                <td><p>{{ lead.region }}</p></td>
                <td><p class="page-td">{{ lead.noOfPages }}</p></td>
                <td>
                    <p *ngIf="lead.date">{{ lead.delivery_date | date }}</p>
                    <p>{{ lead.delivery_date | date:'shortTime' }}</p>
                    <p class="time-left" [ngClass]="{'time-left': !lead.invert, 'time-elapsed': lead.invert}">{{ lead.due_date }}</p>
                </td>
                <td>
                  <ng-container *ngIf="lead.history">
                    <a href="javascript:;" (click)="showFeedback(lead, indx, 'Proof-Comments')" *ngIf="!lead.loadingFeed">
                      <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.873 0H5.12695C2.29988 0 0 2.23443 0 4.98105V12.6743C0 14.8659 1.48106 16.7747 3.6272 17.3857L6.10332 19.7915C6.24084 19.925 6.427 20 6.62136 20C6.81553 20 7.00188 19.925 7.13921 19.7915L9.41067 17.5845H19.873C22.7001 17.5845 25 15.3501 25 12.6035V4.98105C25 2.23443 22.7001 0 19.873 0ZM23.5352 12.6035C23.5352 14.5653 21.8924 16.1614 19.873 16.1614H9.1074C8.91323 16.1614 8.72688 16.2364 8.58955 16.3698L6.62136 18.282L4.52518 16.2455C4.43115 16.1541 4.31328 16.0893 4.18415 16.0581C2.58312 15.671 1.46484 14.2796 1.46484 12.6743V4.98105C1.46484 3.01921 3.10764 1.42316 5.12695 1.42316H19.873C21.8924 1.42316 23.5352 3.01921 23.5352 4.98105V12.6035Z" fill="#00A5DC"/>
                        <path d="M17.1506 6.82312H7.84961C7.44506 6.82312 7.11719 7.14185 7.11719 7.5347C7.11719 7.92774 7.44506 8.24628 7.84961 8.24628H17.1506C17.5552 8.24628 17.883 7.92774 17.883 7.5347C17.883 7.14185 17.5552 6.82312 17.1506 6.82312Z" fill="#00A5DC"/>
                        <path d="M17.1506 9.33826H7.84961C7.44506 9.33826 7.11719 9.6568 7.11719 10.0498C7.11719 10.4429 7.44506 10.7614 7.84961 10.7614H17.1506C17.5552 10.7614 17.883 10.4429 17.883 10.0498C17.883 9.6568 17.5552 9.33826 17.1506 9.33826Z" fill="#00A5DC"/>
                      </svg>
                    </a>

                    <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="lead.loadingFeed"></i>
                  </ng-container>
                </td>
                <td>
                  <div class="pos-rel">
                    <a href="javascript:;" *ngIf="lead.assignMe && !lead.loading" (click)="openAssignToMe_PR_Modal(indx)">
                      <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.1488 2.87993C16.9664 0.703647 13.8688 -0.384493 10.912 0.123306C10.8416 0.123306 10.8416 0.123306 10.7712 0.195848C10.2784 0.123306 9.7856 0.050763 9.2928 0.050763C6.688 0.050763 4.224 1.06636 2.3936 2.95247C2.112 3.24264 2.112 3.6779 2.3936 3.96807C2.6752 4.25824 3.0976 4.25824 3.3792 3.96807C4.928 2.29959 6.9696 1.42907 9.2224 1.42907C11.4752 1.42907 13.5168 2.29959 14.9952 3.89553C18.2336 7.23249 18.2336 12.6732 14.9952 16.0102C13.4464 17.6786 11.4048 18.5491 9.152 18.5491C6.9696 18.5491 4.8576 17.6061 3.3088 16.0102C3.0272 15.72 2.6048 15.72 2.3232 16.0102C2.0416 16.3003 2.0416 16.7356 2.3232 17.0257C4.1536 18.9119 6.6176 19.9275 9.2224 19.9275C9.7152 19.9275 10.208 19.8549 10.6304 19.8549C10.6304 19.8549 10.6304 19.8549 10.7008 19.8549C11.1936 19.9275 11.7568 20 12.2496 20C14.8544 20 17.3184 18.9119 19.1488 17.0257C22.9504 13.1084 22.9504 6.79723 19.1488 2.87993ZM18.1632 16.0827C17.3184 16.9532 16.3328 17.6061 15.2768 18.0413C15.6288 17.7512 15.9104 17.5335 16.192 17.1708C18.0224 15.2122 19.008 12.7457 19.008 10.0617C19.008 7.37757 18.0928 4.83858 16.192 2.95247C15.84 2.58976 15.488 2.29959 15.0656 2.00942C16.192 2.44467 17.3184 3.09756 18.1632 3.96807C21.4016 7.30503 21.4016 12.7457 18.1632 16.0827Z" fill="#F07527"/>
                        <path d="M3.3088 9.9891C3.3088 9.55384 3.0272 9.26367 2.6048 9.26367H0.704C0.2816 9.26367 0 9.55384 0 9.9891C0 10.4244 0.2816 10.7145 0.704 10.7145H2.6048C2.9568 10.7145 3.3088 10.4244 3.3088 9.9891Z" fill="#F07527"/>
                        <path d="M4.50555 9.98913C4.50555 10.4244 4.78715 10.7146 5.20955 10.7146H10.8416L7.67355 13.979C7.39195 14.2691 7.39195 14.7044 7.67355 14.9946C7.81435 15.1397 7.95515 15.2122 8.16635 15.2122C8.30715 15.2122 8.51835 15.1397 8.65915 14.9946L13.024 10.4969C13.3056 10.2068 13.3056 9.7715 13.024 9.48133L8.65915 4.98368C8.37755 4.69351 7.95515 4.69351 7.67355 4.98368C7.39195 5.27385 7.39195 5.70911 7.67355 5.99928L10.8416 9.2637H5.20955C4.78715 9.2637 4.50555 9.55387 4.50555 9.98913Z" fill="#F07527"/>
                      </svg>
                    </a>

                    <!-- Loader for action -->
                    <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="lead.loading"></i>

                    <!-- ProofReader Assign Me Model -->
                    <div class="paid-modal-m deleteModal">
                      <div class="modal fade" [id]="'pr_assignme_modal' + indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel2">Are you sure you want to assign this Order?</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="action-btns">
                                <a href="javascript:;" data-dismiss="modal" aria-label="Close">NO</a>
                                <a href="javascript:;" class="yes-btn bgBlue" (click)="assignToMe_PR()">YES</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </ng-container>
        </table>
      </div>
    </div>
  </div>
</section>

<!-- floating alert starts -->
<ng-container *ngIf="leads.alertMessage && leads.data && leads.data.length > 0">
    <div class="floatingAlert" *ngIf="floatingAlert">
        <button type="button" class="close" (click)="closeFloatingAlert();">
          <i class="fa fa-times"></i>
        </button>
        <p>{{ leads.alertMessage }}</p>
    </div>
</ng-container>
<!-- floating alert ends -->

<!-- QA Feedback Modal -->
<div class="qa-feedback-m">
  <div class="modal fade" id="qaFeedBack_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel2" *ngIf="leads.data && leads.data[lead_Index]">Proofreader Feedback -- {{ leads.data[lead_Index].order_id }}</h5>
      </div>
      <div class="modal-content">
        <div class="modal-body" *ngIf="comments.length > 0">
          <ng-container  *ngFor="let comment of comments">
            <div class="feedback-madal comment-box">
              <div class="ratings" *ngIf="comment.qaRating">
                <div class="stars">
                  <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 1 , 'active-half': comment.qaRating > 0 && comment.qaRating < 1 }"></i>
                  <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 2 , 'active-half': comment.qaRating > 1 && comment.qaRating < 2 }"></i>
                  <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 3 , 'active-half': comment.qaRating > 2 && comment.qaRating < 3 }"></i>
                  <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 4 , 'active-half': comment.qaRating > 3 && comment.qaRating < 4}"></i>
                  <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 5 , 'active-half': comment.qaRating > 4 && comment.qaRating < 5}"></i>
                </div>
                <span class="rating-points">{{ comment.qaRating }}/5</span>
              </div>
              <p class="comment-txt" [innerHtml]="comment.notes | safeHtml:'html' "></p>
              <p class="date-comment">{{ comment.date | customDatePipe: 'dateTime' }}</p>
              <p class="qa-name">By: {{ agentSearch(comment.user_id, proofreaders) }}</p>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
